// Disable elements
window.disableElements = function (elements, loader) {

    loader = typeof loader !== 'undefined' ? loader : true;

    elements.each(function () {

        $(this).addClass('disabled');

        if ($(this).is('a, area, link, button, input, select, textarea, optgroup, option, fieldset')) {

            $(this).attr('disabled', true);
        }

        if (loader) {

            $(this).html('<i class="material-icons">autorenew</i><span class="sr-only loading-text">' + $(this).html() + '</span>');
        }
    });
}

window.skrinkBarMagFavorisText = function() {
    const flowtype = require('flowtype-js');

    var barElement = $('#bHeaderMobile');
    // Loop through all of the dynamic divs on the page
    if(barElement.length > 0) {
      let fl = flowtype(barElement.get(0), {
        minFont   : 13,
        maxFont   : 18,
       });
    }
}

// Enable elements
window.enableElements = function (elements, loader) {

    loader = typeof loader !== 'undefined' ? loader : true;

    elements.each(function () {

        if (loader) {

            $(this).html($(this).find('.loading-text').html());
        }

        if ($(this).is('a, area, link, button, input, select, textarea, optgroup, option, fieldset')) {

            $(this).attr('disabled', false);
        }

        $(this).removeClass('disabled');
    });
}

// Get URL parameters
window.getUrlParameters = function () {

    var result = [];
    var url = window.location.search.substring(1);
    var parameters = url.split('&');
    var parameter;
    var i;

    for (i = 0; i < parameters.length; i++) {

        parameter = parameters[i].split('=');
        result[parameter[0]] = parameter[1] === undefined ? true : decodeURIComponent(parameter[1]);
    }

    return result;
};

/**
 * Get the URL parameters
 * source: https://css-tricks.com/snippets/javascript/get-url-variables/
 * @param  {String} url The URL
 * @return {Object}     The URL parameters
 */
window.getParams = function (url) {
	var params = {};
	var parser = document.createElement('a');
	parser.href = url;
	var query = parser.search.substring(1);
	var vars = query.split('&');
	for (var i = 0; i < vars.length; i++) {
		var pair = vars[i].split('=');
		params[pair[0]] = decodeURIComponent(pair[1]);
	}
	return params;
};

// Clean modal
window.cleanModal = function (element) {

    element = element instanceof $ ? element : $(element);

    element.find('.invalid-feedback').remove();
    element.find('.alert-success, .alert-danger').addClass('d-none').empty();
    element.find('.is-invalid').removeClass('is-invalid');
}

$(window).on('load', function () {
    $('body').removeClass('body-on-load');
});




function showPubs() {

    
    // on met des pubs à chaque element qui a un ID en div-gpt* dans une .pub
    setTimeout(function () {
        if (typeof googletag !== 'undefined' ) {
            $('.pub [id^=div-gpt]').each(function () {
                googletag.display($(this).attr('id'));
            });
        }

    }, 500);
}
$(document).ready(function () {

    // Datatables
    if (typeof ($.fn.dataTable) !== 'undefined') {

        $.extend(true, $.fn.dataTable.defaults, {
            language: {
                url: '/json/' + Lang.getLocale() + '/jquery.dataTables.json'
            }
        });
    }

    // Fix readonly
    $('body').on('click', '.readonly', function () {

        return false;
    });

    // Disable submit button on form sending
    $('body').on('submit', 'form', function () {

        disableElements($(this).find('.send-form'));
    });


   // showPubs();   //géré par tarteaucitron
});


